import React, { useState } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import clsx from 'clsx'

import * as styles from './Header.module.css'

function Header() {
  const [mobileNavOpened, setMobileNavOpened] = useState(false)

  const data = useStaticQuery(graphql`
    query Header {
      allGhostSettings {
        nodes {
          ...GhostSettingsFields
        }
      }
    }
  `)

  const [site] = data.allGhostSettings.nodes

  return (
    <header id="main-header">
      <div className="clearfix container">
        <Link to="/">
          <img id="logo" src={site.logo} alt={site.title} />
        </Link>
        <div id="et-top-navigation">
          <nav id="top-menu-nav">
            <ul id="top-menu" className="nav">
              <li
                id="menu-item-57"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-57"
              >
                <Link to="/#why">Why make a will?</Link>
              </li>
              <li
                id="menu-item-58"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-58"
              >
                <Link to="/#how">How does it work?</Link>
              </li>
              <li
                id="menu-item-59"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-59"
              >
                <Link to="/#price">How much will it cost?</Link>
              </li>
              <li
                id="menu-item-1777"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1777"
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a>More</a>
                <ul className="sub-menu">
                  <li
                    id="menu-item-1782"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1782"
                  >
                    <Link to="/knowledge-base">Knowledge Base</Link>
                  </li>
                  <li
                    id="menu-item-1778"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1778"
                  >
                    <Link to="/knowledge-base/the-basics">The Basics</Link>
                  </li>
                  <li
                    id="menu-item-1787"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1787"
                  >
                    <Link to="/knowledge-base/friends-family">
                      Friends &amp; Family
                    </Link>
                  </li>
                  <li
                    id="menu-item-1792"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1792"
                  >
                    <Link to="/knowledge-base/your-assets">Your Assets</Link>
                  </li>
                  <li
                    id="menu-item-1796"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1796"
                  >
                    <Link to="/knowledge-base/your-wishes">Your Wishes</Link>
                  </li>
                  <li
                    id="menu-item-1801"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1801"
                  >
                    <Link to="/knowledge-base/what-happens-next">
                      What Happens Next?
                    </Link>
                  </li>
                  <li
                    id="menu-item-1805"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1805"
                  >
                    <Link to="/knowledge-base/glossary">Glossary</Link>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1825"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1825"
              >
                <Link to="/blog">Blog</Link>
              </li>
              <li
                id="menu-item-835"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-835"
              >
                <a href="https://app.affio.co.uk/#/register">Get Started</a>
              </li>
              <li
                id="menu-item-1614"
                className="login menu-item menu-item-type-custom menu-item-object-custom menu-item-1614"
              >
                <a href="https://app.affio.co.uk/#/login/">Log In</a>
              </li>
            </ul>
          </nav>
          <div id="et_mobile_nav_menu">
            <div
              role="button"
              className={clsx(
                'mobile_nav',
                mobileNavOpened ? 'opened' : 'closed',
              )}
            >
              <button
                type="button"
                className={clsx('mobile_menu_bar', styles.mobileMenuToggle)}
                onClick={() => setMobileNavOpened(!mobileNavOpened)}
              >
                <span className={styles.mobileMenuToggleText}>Menu</span>
              </button>
              <ul
                id="mobile_menu"
                className={clsx('et_mobile_menu', styles.mobileMenu)}
                style={{ display: mobileNavOpened ? 'block' : 'none' }}
              >
                <li
                  id="menu-item-57"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-57 et_first_mobile_item"
                >
                  <Link to="/#why">Why make a will?</Link>
                </li>
                <li
                  id="menu-item-58"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-58"
                >
                  <Link to="/#how">How does it work?</Link>
                </li>
                <li
                  id="menu-item-59"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-59"
                >
                  <Link to="/#price">How much will it cost?</Link>
                </li>
                <li
                  id="menu-item-1777"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1777"
                >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a>More</a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-1782"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1782"
                    >
                      <Link to="/knowledge-base">Knowledge Base</Link>
                    </li>
                    <li
                      id="menu-item-1778"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1778"
                    >
                      <Link to="/knowledge-base/the-basics">The Basics</Link>
                    </li>
                    <li
                      id="menu-item-1787"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1787"
                    >
                      <Link to="/knowledge-base/friends-family">
                        Friends &amp; Family
                      </Link>
                    </li>
                    <li
                      id="menu-item-1792"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1792"
                    >
                      <Link to="/knowledge-base/your-assets">Your Assets</Link>
                    </li>
                    <li
                      id="menu-item-1796"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1796"
                    >
                      <Link to="/knowledge-base/your-wishes">Your Wishes</Link>
                    </li>
                    <li
                      id="menu-item-1801"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1801"
                    >
                      <Link to="/knowledge-base/what-happens-next">
                        What Happens Next?
                      </Link>
                    </li>
                    <li
                      id="menu-item-1805"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1805"
                    >
                      <Link to="/knowledge-base/glossary">Glossary</Link>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-1825"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1825"
                >
                  <Link to="/blog">Blog</Link>
                </li>
                <li
                  id="menu-item-835"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-835"
                >
                  <a href="https://app.affio.co.uk/#/register">Get Started</a>
                </li>
                <li
                  id="menu-item-1614"
                  className="login menu-item menu-item-type-custom menu-item-object-custom menu-item-1614"
                >
                  <a href="https://app.affio.co.uk/#/login/">Log In</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
